import { getDefaultExportFromCjs as r } from "./index361.js";
import { __require as o } from "./index766.js";
var t = o();
const m = /* @__PURE__ */ r(t);
export {
  m as default
};
